import { ActionCreatorWithPayload, ActionCreatorWithoutPayload } from "@reduxjs/toolkit"
import createAlert from "@modules/app/scripts/alert/createAlert"
import { setAlert } from "@modules/app/reducers/alertReducer"
import { DispatchType } from "@redux/types"
import info from "@utils/info"
import handleFunction from "../handleFunction"
import { HandleResponseErrorReducers, HandleResponseOptions, HandleResponseReducers, InitRequestReducers, ResponsePattern, ResponseStatesPattern } from "./types"

export const responseInitialValues: ResponseStatesPattern<any> = {
    data: null,
    loading: false,
    error: false,
    message: ''
}

export function checkResponseType(initiator: string, response: ResponsePattern<any>){
    try {
        Object.keys(response).forEach(key => {
            if(!['flagErro', 'listaMensagens', 'listaResultados'].includes(key)){
                throw new Error(`${initiator} response type is invalid. Key: ${key} not expected.`)
            }
        })
        return true
    } catch (error) {
        info.error('checkResponseType',error)
        return false
    }
}

export function initRequest<T>(dispatch: DispatchType, { reset, loading }: InitRequestReducers, resetData?: ActionCreatorWithPayload<T | null>){
    if(!!resetData){
        dispatch(resetData(null))
    }

    dispatch(reset())
    dispatch(loading())
}

export function handleResponseError(
    initiator: string, 
    dispatch: DispatchType, 
    reducers: HandleResponseErrorReducers, 
    error: any, 
    options?: HandleResponseOptions
){
    info.error(`response ${initiator}`, error)
    dispatch(reducers.message(error.message ?? JSON.stringify(error)))
    dispatch(reducers.error())
    if(!!options){
        const { onError, messages } = options

        if(onError){
            handleFunction(dispatch, onError)
        }
        if(messages && !!messages.errorMessage){
            dispatch(setAlert(createAlert('error', messages.errorMessage.text ?? error.message ?? JSON.stringify(error))))
        }
    }
}

export function handleResponse<T>(
    initiator: string,
    dispatch: DispatchType,
    response: ResponsePattern<T> | null, 
    reducers: HandleResponseReducers, 
    options?: HandleResponseOptions
){
    return new Promise<T>((resolve) => {
        try {
            if(!!response){
                dispatch(reducers.data(response))
                if(response.flagErro === false){
                    if(options){
                        const { onSuccess, messages } = options

                        if(onSuccess){
                            handleFunction(dispatch, onSuccess)
                        }
                        if(messages && !!messages.successMessage){
                            dispatch(setAlert(createAlert('success', messages.successMessage.text ?? response.listaMensagens[0])))
                        }
                    }
                    resolve(response.listaResultados)
                }else throw response.listaMensagens[0]
            }else{
                const errorMessage = { message: 'Erro na requisição' }
                throw errorMessage
            }
        } catch (error: any) {
            handleResponseError(initiator, dispatch, reducers, error, options)
        }
    })
}

export function toResponsePattern<T>(data: T): ResponsePattern<T> {
    return {
        flagErro: false,
        listaMensagens: [] as string[],
        listaResultados: data as T,
    }
}